
import React from "react";
import { useCounter, useInView } from "../../hooks";
import styles from "../../assets/style.module.css";

export interface HeroStatProps {
    label: string;
    value: number | string;
}

function HeroStat({ label, value }: HeroStatProps) {

    const [ref, inView] = useInView(0.1);
    const numeric = typeof value === "number" ? value : Number(value);
    const isNumeric = value !== "" && !Number.isNaN(numeric);
    const count = useCounter(isNumeric ? numeric : 0, inView, 2000);

    return (<div ref={ref} className={styles["hero-stat"]}>
        <span className={styles["hero-stat-val"]}>{isNumeric ? count : value}</span>
        <span className={styles["hero-stat-lbl"]}>{label}</span>
    </div>);
}

export default HeroStat;
